import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 350,
    fontSize: '14px',
    color: '#fff',
    padding: '10px 15px',
  },
});

export default function CustomTooltip({ title, children, ...props }) {
  return (
    <StyledTooltip title={title} arrow placement="top" {...props}>
      {children}
    </StyledTooltip>
  );
}
